export default function () {
  return {
    data: [],
    form: {
      id: null,
      line_id: null,
      code: '',
      description: '',
      commission_percentage: null,
      commission_value: null,
    },
    loading: false,
    saving: false,
    deleting: false,
  }
}


// WEBPACK FOOTER //
// ./src/modules/sublinesb/state.js